import React from 'react';

const collectNWin = 'Collect \'N Win';

const copyDefaults = {
  login: {
    header: 'Log in to New York Lottery',
    body: 'Ready for more ways to play? Sign in here to enjoy the app\'s features, including the new NYL+ program, offering fun second chance games and exclusive promotions with more chances to win.',
    line2: `(If you have a ${collectNWin} account, use those credentials to join in all the fun of NYL+.)`,
  },
  register: {
    header: 'WELCOME TO THE NEW YORK LOTTERY REGISTRATION PAGE!',
    body: 'Create an account and join the new NYL+ program, featuring fun second chance games and exclusive promotions with more chances to win. (Fields with asterisks are required.)',
    preLinkText: `Are you a ${collectNWin} User? `,
    linkText: 'Log in',
    postLinkText: ' to NYL+ with your existing credentials.',
    linkUrl: '/login',
  },
  resetPassword: {
    header: 'Reset Your Password',
    body: `Enter the email address associated with your NYL+ account (formerly your ${collectNWin} or your current Official NY Lottery account). If you\'re registered, we\'ll send you an email with instructions for resetting your password.`,
  },
  confirmResetPassword: {
    header: 'Reset password confirmation',
    body: 'Please enter your new password and confirm in the fields below. Then press RESET PASSWORD',
  },
  verifyEmail: {
    header: '',
    body: '',
  },
  updateProfile: {
    header: 'Update Profile',
    body: 'Update your profile here.',
  },
  migrateProfile: {
    header: 'Please verify your details',
    body: 'In order to better protect your account, all New York Lottery associated accounts will use one login, everywhere! To keep it secure we are moving your data to one location.',
    line2: 'Please verify that the information below is correct and re-enter your address details.',
  },
  confirmOtp: {
    header: 'Verify your phone number',
    body: 'Confirm your account with a one-time code sent to your phone by text or voice call.',
  },
  verifySsn: {
    header: '',
    body: '',
  },
  migrationFailed: {
    header: '',
    body: '',
  },
  userDuplicated: {
    header: '',
    body: '',
  },
  selectGovIdType: {
    header: 'Welcome to the New York Lottery Registration Page',
    body: 'In order to set up your account, we will need to verify your identity with your US Driver\'s License/ID Card or International Passport.',
  },
  govIdResponse: {
    header: '',
    body: '',
  },
};

export const getCopy = (path) => {
  if (path.includes('login')) {
    return copyDefaults.login;
  } else if (path.includes('register')) {
    return copyDefaults.register;
  } else if (path.includes('reset-password') && !path.includes('confirm-')) {
    return copyDefaults.resetPassword;
  } else if (path.includes('confirm-reset-password')) {
    return copyDefaults.confirmResetPassword;
  } else if (path.includes('verify-email')) {
    return copyDefaults.verifyEmail;
  } else if (path.includes('idv/otp')) {
    return copyDefaults.confirmOtp;
  } else if (path.includes('idv/migrate')) {
    return copyDefaults.migrateProfile;
  } else if (path.includes('update-profile')) {
    return copyDefaults.updateProfile;
  } else if (path.includes('idv/ssn4')) {
    return copyDefaults.verifySsn;
  } else if (path.includes('idv/failed')) {
    return copyDefaults.migrationFailed;
  } else if (path.includes('idv/select-gov-id-type')) {
    return copyDefaults.selectGovIdType;
  } else if (path.includes('gov-id-response')) {
    return copyDefaults.govIdResponse;
  } else if (path.includes('user-duplicated')) {
    return copyDefaults.userDuplicated;
  }
  return copyDefaults.register;
};
